import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-grafico',
  templateUrl: './grafico.component.html',
  styleUrls: ['./grafico.component.scss'],
})
export class GraficoComponent implements OnInit {
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() descriptionValue: string = '';
  @Input() description2: string = '';
  @Input() description2Value: string = '';
  @Input() totalValue: string = '';
  @Input() totalText: string = 'Total';

  constructor() {}

  ngOnInit() {}
}
